import { render, staticRenderFns } from "./ColorBoxTool.vue?vue&type=template&id=d5341e9e&"
import script from "./ColorBoxTool.vue?vue&type=script&lang=js&"
export * from "./ColorBoxTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports